import React from "react";
import './Footer.css';
import { Link } from 'react-router-dom';
import { scrollToTop } from './Navbar.js';

function Footer() {
    return (
        <footer className="main-footer">
            <div className="footer-container">
                <div className="footer-content">

                    {/* ── Branding ─────────────────────────────────── */}
                    <div className="footer-section">
                        <div className="footer-brand">
                            <div className="footer-brand-logo-container">
                            <img
                                src="/images/Titre_transparent_blanc.png"
                                alt="Trilogie Restaurant"
                                className='navbar-logo'
                                />
                            </div>
                            <div className="footer-divider" />
                        </div>
                        <p className="footer-description">
                            Une expérience culinaire unique où tradition et modernité
                            se rencontrent. Découvrez des saveurs raffinées dans une
                            ambiance chaleureuse et élégante.
                        </p>
                    </div>

                    {/* ── Navigation ───────────────────────────────── */}
                    <div className="footer-section">
                        <div className="footer-section-header">
                            <h3 className="footer-subtitle">Navigation</h3>
                            <div className="footer-divider-small" />
                        </div>
                        <nav className="footer-nav">
                            <Link to="/" onClick={scrollToTop} className="footer-link">Accueil</Link>
                            <Link to="/menu" onClick={scrollToTop} className="footer-link">Menu</Link>
                            <Link to="/equipe" onClick={scrollToTop} className="footer-link">Équipe</Link>
                            <Link to="/traiteur" onClick={scrollToTop} className="footer-link">Traiteur</Link>
                            <Link to="/vins" onClick={scrollToTop} className="footer-link">Vins</Link>
                            <Link to="/terrasse" onClick={scrollToTop} className="footer-link">Terrasse</Link>
                            <Link to="/bon-cadeau" onClick={scrollToTop} className="footer-link">Bon cadeau</Link>
                            <Link
                                to="https://loudstphotography.pixieset.com/trilogie-1/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                            >
                                Galerie <i className="fa-solid fa-arrow-up-right-from-square" />
                            </Link>
                            <Link
                                to="https://bookings.zenchef.com/results?rid=379037&pid=1001"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                            >
                                Réservations <i className="fa-solid fa-arrow-up-right-from-square" />
                            </Link>
                        </nav>
                    </div>

                    {/* ── Horaires ─────────────────────────────────── */}
                    <div className="footer-section">
                        <div className="footer-section-header">
                            <h3 className="footer-subtitle">Horaires</h3>
                            <div className="footer-divider-small" />
                        </div>
                        <div className="footer-contact">
                            <p>Mardi : 12h – 13h45</p>
                            <p>Mercredi : 12h – 13h45</p>
                            <p>Jeudi : 12h – 13h45 / 19h – 20h45</p>
                            <p>Vendredi : 12h – 13h45 / 19h – 20h45</p>
                            <p>Samedi : 19h – 20h45</p>
                        </div>
                    </div>

                    {/* ── Contact ──────────────────────────────────── */}
                    <div className="footer-section">
                        <div className="footer-section-header">
                            <h3 className="footer-subtitle">Contact</h3>
                            <div className="footer-divider-small" />
                        </div>
                        <div className="footer-contact">
                            <p>Rue des vennes 42</p>
                            <p>4020 Liège, Belgique</p>
                            <p className="footer-contact-spacing">+32 470 45 36 93</p>
                            <p>trilogie.restaurant@gmail.com</p>
                        </div>
                        <div className="footer-social">
                            <Link
                                to="https://www.instagram.com/trilogie.restaurant/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="Instagram"
                            >
                                <i className="fa-brands fa-instagram" />
                            </Link>
                            <Link
                                to="https://www.facebook.com/people/Trilogie/61580320587405/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="Facebook"
                            >
                                <i className="fa-brands fa-facebook-f" />
                            </Link>
                        </div>
                    </div>

                </div>
            </div>

            {/* ── Bas du footer ─────────────────────────────────── */}
            <div className="footer-bottom">
                <p className="footer-copyright">
                    © 2026 Trilogie Restaurant. Tous droits réservés.
                </p>
                <div className="footer-legal">
                    <Link to="/mentions" className="footer-legal-link">
                        Mentions légales
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
